import BaseAccordionDetails from '@material-ui/core/ExpansionPanelDetails'

const AccordionDetails = BaseAccordionDetails

export default AccordionDetails
